import { FC } from 'react';
import { rarity } from '@prisma/client';
import { SpriteIcon, SpriteIconProps } from '@components/Sprites/SpriteIcon';
import { getRarityById } from '@services/toys/helpers';
interface Props extends Omit<SpriteIconProps, 'name'> {
  rarityId: rarity['id'];
}
export const RarityIcon: FC<Props> = ({
  rarityId,
  ...props
}) => {
  const name = getRarityById(rarityId);
  if (!name) return null;
  return <SpriteIcon name={name} {...props} data-sentry-element="SpriteIcon" data-sentry-component="RarityIcon" data-sentry-source-file="RarityIcon.tsx" />;
};